import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ConfirmationModal.scss';
import ModalOverlay from '../ModalOverlay/ModalOverlay';
function ConfirmationModal({ isOpen, onClose, onConfirm, title = 'Confirm Action', // Default title
message, confirmText = 'Confirm', cancelText = 'Cancel', isLoading = false, hideCancel = false, contentClassName, }) {
    if (!isOpen) {
        return null;
    }
    const handleConfirm = () => {
        if (!isLoading) {
            onConfirm();
        }
    };
    const handleClose = () => {
        if (!isLoading) {
            onClose();
        }
    };
    return (_jsx(ModalOverlay, { onClose: handleClose, children: _jsxs("div", { className: `modal-content confirmation-modal${contentClassName ? ` ${contentClassName}` : ''}`, children: [" ", _jsx("h2", { children: title }), _jsx("div", { className: "modal-message", children: typeof message === 'string' ? _jsx("p", { children: message }) : message }), _jsxs("div", { className: "modal-actions", children: [!hideCancel && (_jsx("button", { onClick: handleClose, disabled: isLoading, className: "button-secondary", children: cancelText })), _jsx("button", { onClick: handleConfirm, disabled: isLoading, className: "button-confirm", children: isLoading ? 'Processing...' : confirmText })] })] }) }));
}
export default ConfirmationModal;
